<zelis-dialog>
  <zelis-dialog-header
    [title]="'claim_overlay_header' | translate"
    [caption]="'claim_overlay_header_' + rewardTypeKey + 'caption' | translate"
    dismissable
    data-cy="claim-overlay.container"
  >
  </zelis-dialog-header>

  <mat-dialog-content>
    <div class="fs-16px mb-8">
      {{ 'claim_overlay_' + rewardTypeKey + 'content_1' | translate }}
      <mat-icon
        class="w-4 h-4 align-middle text-blue-500"
        svgIcon="dls-info-circle-light"
        [matTooltip]="'claim_overlay_tooltip_1' | translate"
        matTooltipPosition="above"
        tabindex="0"
      ></mat-icon>
    </div>

    <div *ngIf="data.rewardType !== 'quality_rewards'" class="fs-16px mb-8">
      {{ 'claim_overlay_content_2' | translate }}<br />
      <a
        href="tel:{{ 'smartshopper_pat_phone' | translate }}"
        [innerHTML]="'smartshopper_pat_phone' | translate"
      >
      </a>
    </div>

    <hr />

    <div class="fs-16px mt-8">
      <div class="grid grid-rows-3 grid-flow-col gap-1 grid-cols-[28px_auto]">
        <div class="row-span-3 mr-2">
          <mat-icon
            svgIcon="dls-dollar-signs-sack-light"
            class="align-text-bottom"
          ></mat-icon>
        </div>
        <h3 class="text-palette-m3-system-gray-35 dls-body-1-regular">
          {{ 'claim_overlay_reward_header' | translate | uppercase }}
        </h3>
        <div class="row-span-2">
          <zelis-theme-lozenge
            emphasis="high"
            size="medium"
            color="system-green"
          >
            {{ data.reward }}
          </zelis-theme-lozenge>
        </div>
      </div>

      <div class="grid grid-rows-3 grid-flow-col gap-1 grid-cols-[28px_auto]">
        <div class="row-span-3 mr-2">
          <mat-icon
            svgIcon="dls-file-check-light"
            class="align-text-bottom"
          ></mat-icon>
        </div>
        <h3 class="text-palette-m3-system-gray-35 dls-body-1-regular">
          {{ 'claim_overlay_search_header' | translate | uppercase }}
        </h3>
        <div class="row-span-2">
          <span class="text-medium"
            >{{ data.referenceNumber }}
            <mat-icon
              class="ml-1 w-4 h-4 align-text-top text-blue-500"
              svgIcon="dls-info-circle-light"
              [matTooltip]="'claim_overlay_tooltip_2' | translate"
              matTooltipPosition="above"
              tabindex="0"
            ></mat-icon>
          </span>
        </div>
      </div>

      <div
        class="grid grid-rows-3 grid-flow-col gap-1 grid-cols-[28px_auto] content-start"
      >
        <div class="row-span-3 mr-2">
          <mat-icon
            svgIcon="dls-facility-hospital-light"
            class="align-text-bottom"
          ></mat-icon>
        </div>
        <div class="row-span-2">
          <h3
            *ngIf="data.result.provider_type === 'F'"
            class="text-palette-m3-system-gray-35 dls-body-1-regular"
          >
            {{ 'claim_overlay_facility_header' | translate | uppercase }}
          </h3>
          <span
            *ngIf="data.result.provider_type === 'P'"
            class="text-palette-m3-system-gray-35"
            >{{
              'claim_overlay_professional_header' | translate | uppercase
            }}</span
          >
          <div>
            <span class="text-medium">{{ name }}</span
            ><br />
            {{ address }} <br />
            <a
              href="tel:{{ data.result.phone }}"
              [innerHTML]="data.result.phone | phone"
            >
            </a>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <zelis-dialog-footer [buttons]="buttons"></zelis-dialog-footer>
</zelis-dialog>
